import { ThunkResult, Utilities } from "../../shared/utilities";
import { State } from "../model/State";
import * as Redux from "redux";
import { IProcessVariable } from "../../processEditor/model/IProcessData";
import { SchemaType } from "../../environmentVariables/model/VariableSchema";

export function updateProcessVariableValue(id: number, newValue: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        dispatch(triggerUpdateProcessVariableValueDraft(id, newValue, getState().environmentVariables));
    };
}

export const RECEIVE_PROCESS_VARIABLES = "RECEIVE_PROCESS_VARIABLES";
export function receiveProcessVariables(processVariables: IProcessVariable[]): ReceiveProcessVariablesAction {
    return {
        type: RECEIVE_PROCESS_VARIABLES,
        processVariables: processVariables
    };
}

export const UPDATE_PROCESS_VARIABLE_VALUE_DRAFT = "UPDATE_PROCESS_VARIABLE_VALUE_DRAFT";
export function triggerUpdateProcessVariableValueDraft(id: number, newValue: string, environmentVariables: string[]): UpdateProcessVariableValueDraftAction {
    return {
        type: UPDATE_PROCESS_VARIABLE_VALUE_DRAFT,
        id: id,
        newDisplayValue: newValue,
        environmentVariables: environmentVariables,
    };
}

export const VALIDATE_PROCESS_VARIABLES = "VALIDATE_PROCESS_VARIABLES";
export function triggerValidateProcessVariables(environmentVariables: string[]): ValidateProcessVariablesAction {
    return {
        type: VALIDATE_PROCESS_VARIABLES,
        environmentVariables: environmentVariables,
    };
}

export function addNewEnvironmentVariable(type: SchemaType, name: string, parentName: string | undefined,
    value: string | boolean | string[] | undefined) {
    return async (dispatch: any, getState: any) => {
        try {
            await Utilities.postJsonAndParseResponse("api/environmentVariable/addSchemaWithValue", {
                parentVariableName: parentName,
                name: name,
                type: type,
                value: value
            });

            const fullName = parentName ? parentName + "." + name : name;
            dispatch(addedNewEnvironmentVariable(fullName));
            dispatch(triggerValidateProcessVariables(getState().environmentVariables));
        } catch (error) {
            Utilities.toastError(error);
        }
    };
}

export const ADDED_ENVIRONMENT_VARIABLE = "ADDED_ENVIRONMENT_VARIABLE";
export function addedNewEnvironmentVariable(name: string): AddedNewEnvironmentVariableAction {
    return {
        type: ADDED_ENVIRONMENT_VARIABLE,
        environmentVariableName: name
    };
}

export interface ReceiveProcessVariablesAction extends Redux.Action {
    processVariables: IProcessVariable[];
}

export interface UpdateProcessVariableValueDraftAction extends Redux.Action {
    id: number;
    newDisplayValue: string;
    environmentVariables: string[];
}

export interface ValidateProcessVariablesAction extends Redux.Action {
    environmentVariables: string[];
}

export interface AddedNewEnvironmentVariableAction extends Redux.Action {
    environmentVariableName: string;
}
